import { LocationQuery } from 'vue-router';
import { http } from '../helpers/axiosHelper';

export default class TenantsService {
   async getTenants(query: LocationQuery) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tenant', {
            params: {
               include: 'teams.users,media',
               ...query,
            },
         })
         .then((response) => {
            return response.data;
         });
   }

   async createTenant(body: Object) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tenant', body).then((response) => {
         return response.data;
      });
   }

   async editTenant(id: Number, body: Object) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tenant/' + id, body).then((response) => {
         return response.data;
      });
   }
}
